<!--
  功能：生成报告
  作者：wangwenhao
  邮箱：wangwenhao@gw.com.cn
  时间：2023-07-08 13:24:20
  版本：v1.0
  修改记录：
  修改内容：
  修改人员：
  修改时间：
-->
<template>
  <div class="background-report">
    <!-- 导航栏 -->
    <van-nav-bar title="因子调优报告" class="haider-info">
      <template #left>
        <van-icon name="arrow-left" size="18" color="#ffffff" @click="closeHtml()" />
      </template>
      <template #right>
        <div @click="shareHtml()" v-if="!mnQuery && !searchInfo" style="padding: 10px">
          <i class="right-icon"></i>
        </div>
      </template>
    </van-nav-bar>
    <!-- 生成报告的时间 -->
    <div class="report-time" v-if="!mnQuery">
      报告生成时间: <span> {{ bgTime }} </span>
    </div>
    <!-- 内容页 -->
    <div class="report-content" v-if="!mnQuery">
      <!-- 标题/概览 -->
      <div class="content-gl content-bg">
        <div class="gl-title">{{ yzData.hq ? yzData.hq.FactorName : '' }}</div>
        <div class="gl-code">{{ yzData.hq ? yzData.hq.FactorCode : '' }}</div>
        <div class="gl-tycs" @click="showMbName()">
          <span class="gl-tycs-title">调优参数</span>
          <i :class="showMbInfo ? 'topI' : 'downI'"></i>
        </div>
        <div class="gl-item" :class="showMbInfo ? 'max-gl-item' : ''">
          <ul>
            <li v-for="(item, index) in nameArr" :key="index">
              <span>{{ item }}</span>
            </li>
          </ul>
        </div>
        <div class="gl-desc">
          <div class="gl-desc-title"><span class="desc-title-top">概述:</span>{{ textGl }}</div>
          <div class="gl-desc-item">
            <div class="item-list">
              <div class="item-list-d">
                <i></i>
              </div>
              <div class="item-list-t">{{ textFirst }}</div>
            </div>
            <div class="item-list">
              <div class="item-list-d">
                <i></i>
              </div>
              <div class="item-list-t">
                {{ textSecond }}
              </div>
            </div>
            <div class="item-list">
              <div class="item-list-d">
                <i></i>
              </div>
              <div class="item-list-t">
                {{ textThird }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 涨幅 -->
      <div class="content-bg content-hq">
        <van-row class="content-hq-title" gutter="16">
          <van-col span="12">调优前</van-col>
          <van-col span="12">调优后</van-col>
        </van-row>
        <van-row class="content-hq-item" gutter="16">
          <van-col span="12" class="text-flex-conten">
            <span class="item-left">日涨幅</span>
            <span class="item-right">{{
              yzData.hq ? toFixedNum(yzData.hq.RiZhangFu * 100, 2, '%') : '--'
            }}</span>
          </van-col>
          <van-col span="12" class="text-flex-conten">
            <span class="item-left">日涨幅</span>
            <span
              class="item-right text-flex-conten"
              :class="
                judgeColor(
                  tyData.hq
                    ? (1+yzData.hq.RiZhangFu) > (1+tyData.hq.RiZhangFu)
                      ? -1
                      : (1+yzData.hq.RiZhangFu) < (1+tyData.hq.RiZhangFu)
                      ? 1
                      : 0
                    : 0
                )
              "
              >{{ tyData.hq ? toFixedNum(tyData.hq.RiZhangFu * 100, 2, '%') : '--' }}
              <i
                :class="
                  tyData.hq
                    ? (1+yzData.hq.RiZhangFu) > (1+tyData.hq.RiZhangFu)
                      ? 'greenDown'
                      : (1+yzData.hq.RiZhangFu) < (1+tyData.hq.RiZhangFu)
                      ? 'redTop'
                      : ''
                    : ''
                "
              ></i>
            </span>
          </van-col>
        </van-row>
        <van-row class="content-hq-item" gutter="16">
          <van-col span="12" class="text-flex-conten">
            <span class="item-left">近一年</span>
            <span class="item-right">{{
              yzData.syfx ? toFixedNum(yzData.syfx.StageIncome[4], 2, '%') : '--'
            }}</span>
          </van-col>
          <van-col span="12" class="text-flex-conten">
            <span class="item-left">近一年</span>
            <span
              class="item-right text-flex-conten"
              :class="
                judgeColor(
                  yzData.syfx
                    ? yzData.syfx.StageIncome[4] > tyData.syfx.StageIncome[4]
                      ? -1
                      : yzData.syfx.StageIncome[4] < tyData.syfx.StageIncome[4]
                      ? 1
                      : 0
                    : 0
                )
              "
              >{{ tyData.syfx ? toFixedNum(tyData.syfx.StageIncome[4], 2, '%') : '--' }}
              <i
                :class="
                  tyData.hq
                    ? yzData.syfx.StageIncome[4] > tyData.syfx.StageIncome[4]
                      ? 'greenDown'
                      : yzData.syfx.StageIncome[4] < tyData.syfx.StageIncome[4]
                      ? 'redTop'
                      : ''
                    : ''
                "
              ></i>
            </span>
          </van-col>
        </van-row>
        <van-row class="content-hq-item" gutter="16">
          <van-col span="12" class="text-flex-conten">
            <span class="item-left">今日信号</span>
            <span class="item-right">{{ yzData.hq ? yzData.hq.XinHaoShuLiang : '--' }}只</span>
          </van-col>
          <van-col span="12" class="text-flex-conten">
            <span class="item-left">今日信号</span>
            <span class="item-right">{{ tyData.hq ? tyData.hq.XinHaoShuLiang : '--' }}只</span>
          </van-col>
        </van-row>
      </div>
      <!-- 图表信息 -->
      <div class="content-bg content-tb">
        <!-- 走势收益/涨跌分布/行业分布 -->
        <van-tabs
          v-model="active"
          animated
          color="#286DF7"
          title-active-color="#286DF7"
          title-inactive-color="#555555"
          line-width="16px"
          line-height="2px"
          @rendered="onClickTabs"
        >
          <van-tab title="近一年走势"> <div class="tb-height" id="zssy"></div> </van-tab>
          <van-tab title="涨跌分布"> <div class="tb-height" id="zdfb"></div> </van-tab>
          <van-tab title="行业分布">
            <div class="tb-height2">
              <div class="tb-chart" style="margin-right: 2px">
                <div class="hyfb-text">调优前</div>
                <div class="hyfb-chart" id="hyfbFront"></div>
              </div>
              <div class="tb-chart" style="margin-left: 2px">
                <div class="hyfb-text">调优后</div>
                <div class="hyfb-chart" id="hyfbBehind"></div>
              </div>
            </div>
          </van-tab>
        </van-tabs>
      </div>
      <!-- 报告表格数据 -->
      <div class="content-bg content-data">
        <van-row type="flex" justify="space-between">
          <van-col span="6">
            <div class="data-text text-left">指标名称</div>
          </van-col>
          <van-col span="6">
            <div class="data-text text-right">调优前</div>
          </van-col>
          <van-col span="6">
            <div class="data-text text-right">调优后</div>
          </van-col>
          <van-col span="6">
            <div class="data-text text-right">变动百分比</div>
          </van-col>
          <van-col span="24">
            <div class="data-title">阶段涨跌统计</div>
          </van-col>
          <van-col span="6">
            <div class="data-text2 text-left">近一周涨跌幅</div>
          </van-col>
          <van-col span="6">
            <div class="data-text2 text-right">
              {{ tyData.syfx ? toFixedNum(yzData.syfx.StageIncome[0], 2, '%') : '--' }}
            </div>
          </van-col>
          <van-col span="6">
            <div class="data-text2 text-right">
              {{ tyData.syfx ? toFixedNum(tyData.syfx.StageIncome[0], 2, '%') : '--' }}
              <i
                :class="
                  tyData.hq
                    ? setSyTongBi(yzData.syfx.StageIncome[0], tyData.syfx.StageIncome[0]) < 0
                      ? 'greenDown'
                      : setSyTongBi(yzData.syfx.StageIncome[0], tyData.syfx.StageIncome[0]) > 0
                      ? 'redTop'
                      : ''
                    : ''
                "
              ></i>
            </div>
          </van-col>
          <van-col span="6">
            <div
              class="data-text2 text-right"
              :class="
                judgeColor(
                  tyData.syfx
                    ? setSyTongBi(yzData.syfx.StageIncome[0], tyData.syfx.StageIncome[0])
                    : 0
                )
              "
            >
              {{
                tyData.syfx
                  ? setSyTongBi(yzData.syfx.StageIncome[0], tyData.syfx.StageIncome[0])
                  : '--'
              }}%
            </div>
          </van-col>
          <van-col span="6">
            <div class="data-text2 text-left">近一月涨跌幅</div>
          </van-col>
          <van-col span="6">
            <div class="data-text2 text-right">
              {{ tyData.syfx ? toFixedNum(yzData.syfx.StageIncome[1], 2, '%') : '--' }}
            </div>
          </van-col>
          <van-col span="6">
            <div class="data-text2 text-right">
              {{ tyData.syfx ? toFixedNum(tyData.syfx.StageIncome[1], 2, '%') : '--' }}
              <i
                :class="
                  tyData.hq
                    ? setSyTongBi(yzData.syfx.StageIncome[1], tyData.syfx.StageIncome[1]) < 0
                      ? 'greenDown'
                      : setSyTongBi(yzData.syfx.StageIncome[1], tyData.syfx.StageIncome[1]) > 0
                      ? 'redTop'
                      : ''
                    : ''
                "
              ></i>
            </div>
          </van-col>
          <van-col span="6">
            <div
              class="data-text2 text-right"
              :class="
                judgeColor(
                  tyData.syfx
                    ? setSyTongBi(yzData.syfx.StageIncome[1], tyData.syfx.StageIncome[1])
                    : 0
                )
              "
            >
              {{
                tyData.syfx
                  ? setSyTongBi(yzData.syfx.StageIncome[1], tyData.syfx.StageIncome[1])
                  : '--'
              }}%
            </div>
          </van-col>
          <van-col span="6">
            <div class="data-text2 text-left">近三月涨跌幅</div>
          </van-col>
          <van-col span="6">
            <div class="data-text2 text-right">
              {{ tyData.syfx ? toFixedNum(yzData.syfx.StageIncome[2], 2, '%') : '--' }}
            </div>
          </van-col>
          <van-col span="6">
            <div class="data-text2 text-right">
              {{ tyData.syfx ? toFixedNum(tyData.syfx.StageIncome[2], 2, '%') : '--' }}
              <i
                :class="
                  tyData.hq
                    ? setSyTongBi(yzData.syfx.StageIncome[2], tyData.syfx.StageIncome[2]) < 0
                      ? 'greenDown'
                      : setSyTongBi(yzData.syfx.StageIncome[2], tyData.syfx.StageIncome[2]) > 0
                      ? 'redTop'
                      : ''
                    : ''
                "
              ></i>
            </div>
          </van-col>
          <van-col span="6">
            <div
              class="data-text2 text-right"
              :class="
                judgeColor(
                  tyData.syfx
                    ? setSyTongBi(yzData.syfx.StageIncome[2], tyData.syfx.StageIncome[2])
                    : 0
                )
              "
            >
              {{
                tyData.syfx
                  ? setSyTongBi(yzData.syfx.StageIncome[2], tyData.syfx.StageIncome[2])
                  : '--'
              }}%
            </div>
          </van-col>
          <van-col span="6">
            <div class="data-text2 text-left">近半年涨跌幅</div>
          </van-col>
          <van-col span="6">
            <div class="data-text2 text-right">
              {{ tyData.syfx ? toFixedNum(yzData.syfx.StageIncome[3], 2, '%') : '--' }}
            </div>
          </van-col>
          <van-col span="6">
            <div class="data-text2 text-right">
              {{ tyData.syfx ? toFixedNum(tyData.syfx.StageIncome[3], 2, '%') : '--' }}
              <i
                :class="
                  tyData.hq
                    ? setSyTongBi(yzData.syfx.StageIncome[3], tyData.syfx.StageIncome[3]) < 0
                      ? 'greenDown'
                      : setSyTongBi(yzData.syfx.StageIncome[3], tyData.syfx.StageIncome[3]) > 0
                      ? 'redTop'
                      : ''
                    : ''
                "
              ></i>
            </div>
          </van-col>
          <van-col span="6">
            <div
              class="data-text2 text-right"
              :class="
                judgeColor(
                  tyData.syfx
                    ? setSyTongBi(yzData.syfx.StageIncome[3], tyData.syfx.StageIncome[3])
                    : 0
                )
              "
            >
              {{
                tyData.syfx
                  ? setSyTongBi(yzData.syfx.StageIncome[3], tyData.syfx.StageIncome[3])
                  : '--'
              }}%
            </div>
          </van-col>
          <van-col span="6">
            <div class="data-text2 text-left">近一年涨跌幅</div>
          </van-col>
          <van-col span="6">
            <div class="data-text2 text-right">
              {{ tyData.syfx ? toFixedNum(yzData.syfx.StageIncome[4], 2, '%') : '--' }}
            </div>
          </van-col>
          <van-col span="6">
            <div class="data-text2 text-right">
              {{ tyData.syfx ? toFixedNum(tyData.syfx.StageIncome[4], 2, '%') : '--' }}
              <i
                :class="
                  tyData.hq
                    ? setSyTongBi(yzData.syfx.StageIncome[4], tyData.syfx.StageIncome[4]) < 0
                      ? 'greenDown'
                      : setSyTongBi(yzData.syfx.StageIncome[4], tyData.syfx.StageIncome[4]) > 0
                      ? 'redTop'
                      : ''
                    : ''
                "
              ></i>
            </div>
          </van-col>
          <van-col span="6">
            <div
              class="data-text2 text-right"
              :class="
                judgeColor(
                  tyData.syfx
                    ? setSyTongBi(yzData.syfx.StageIncome[4], tyData.syfx.StageIncome[4])
                    : 0
                )
              "
            >
              {{
                tyData.syfx
                  ? setSyTongBi(yzData.syfx.StageIncome[4], tyData.syfx.StageIncome[4])
                  : '--'
              }}%
            </div>
          </van-col>
          <van-col span="24">
            <div class="data-title">舆情预警</div>
          </van-col>
          <van-col span="6">
            <div class="data-text3 text-left">24h内每支股票平均负面舆情数</div>
          </van-col>
          <van-col span="6">
            <div class="data-text2 text-right">
              {{ yzData.yqNumber ? setYqNum(yzData.yqNumber, yzData.hq.XinHaoShuLiang) : '--' }}
            </div>
          </van-col>
          <van-col span="6">
            <div class="data-text2 text-right">
              {{ tyData.yqNumber ? setYqNum(tyData.yqNumber, tyData.hq.XinHaoShuLiang) : '--' }}
              <i
                :class="
                  yzData.yqNumber && tyData.yqNumber
                    ? setYqTongBi(yzData.yqNumber, tyData.yqNumber) < 0
                      ? 'greenDown'
                      : setYqTongBi(yzData.yqNumber, tyData.yqNumber) > 0
                      ? 'redTop'
                      : ''
                    : ''
                "
              ></i>
            </div>
          </van-col>
          <van-col span="6">
            <div
              class="data-text2 text-right"
              :class="
                judgeColor(
                  yzData.yqNumber && tyData.yqNumber
                    ? setYqTongBi(yzData.yqNumber, tyData.yqNumber)
                    : 0
                )
              "
            >
              {{
                yzData.yqNumber && tyData.yqNumber
                  ? setYqTongBi(yzData.yqNumber, tyData.yqNumber) + '%'
                  : '--'
              }}
            </div>
          </van-col>
          <van-col span="24">
            <div class="data-title">因子池</div>
          </van-col>
          <van-col span="6">
            <div class="data-text3 text-left">一年内因子信号数</div>
          </van-col>
          <van-col span="6">
            <div class="data-text2 text-right">
              {{ yzData.backTest ? yzData.backTest.ReportGradeResult.HistoryCount : '--' }}
            </div>
          </van-col>
          <van-col span="6">
            <div class="data-text2 text-right">
              {{ tyData.backTest ? tyData.backTest.ReportGradeResult.HistoryCount : '--' }}
              <i
                :class="
                  yzData.backTest && tyData.backTest
                    ? setCommonTongBi(
                        yzData.backTest.ReportGradeResult.HistoryCount,
                        tyData.backTest.ReportGradeResult.HistoryCount
                      ) < 0
                      ? 'greenDown'
                      : setCommonTongBi(
                          yzData.backTest.ReportGradeResult.HistoryCount,
                          tyData.backTest.ReportGradeResult.HistoryCount
                        ) > 0
                      ? 'redTop'
                      : ''
                    : ''
                "
              ></i>
            </div>
          </van-col>
          <van-col span="6">
            <div
              class="data-text2 text-right"
              :class="
                judgeColor(
                  yzData.backTest && tyData.backTest
                    ? setCommonTongBi(
                        yzData.backTest.ReportGradeResult.HistoryCount,
                        tyData.backTest.ReportGradeResult.HistoryCount
                      )
                    : 0
                )
              "
            >
              {{
                yzData.backTest && tyData.backTest
                  ? setCommonTongBi(
                      yzData.backTest.ReportGradeResult.HistoryCount,
                      tyData.backTest.ReportGradeResult.HistoryCount
                    ) + '%'
                  : '--'
              }}
            </div>
          </van-col>
          <van-col span="24">
            <div class="data-title">
              <van-row>
                <van-col span="12">
                  <div class="">阶段统计数据（近一年）</div>
                </van-col>
                <van-col span="12" class="text-right-info" @click="showSheet">
                  持股期{{
                    yzData.backTest
                      ? yzData.backTest.BacktestAnalysisResult[this.cgIndex].HoldPeriod
                      : '1'
                  }}天 <i class="text-right-icon"></i>
                </van-col>
              </van-row>
            </div>
          </van-col>
          <van-col span="6">
            <div class="data-text3 text-left">平均区间涨幅</div>
          </van-col>
          <van-col span="6">
            <div class="data-text2 text-right">
              {{
                yzData.backTest
                  ? toFixedNum(
                      yzData.backTest.BacktestAnalysisResult[this.cgIndex].AvgSectionRate * 100,
                      2,
                      '%'
                    )
                  : '--'
              }}
            </div>
          </van-col>
          <van-col span="6">
            <div class="data-text2 text-right">
              {{
                tyData.backTest
                  ? toFixedNum(
                      tyData.backTest.BacktestAnalysisResult[this.cgIndex].AvgSectionRate * 100,
                      2,
                      '%'
                    )
                  : '--'
              }}
              <i
                :class="
                  yzData.backTest && tyData.backTest
                    ? setSyTongBi(
                        yzData.backTest.BacktestAnalysisResult[this.cgIndex].AvgSectionRate * 100,
                        tyData.backTest.BacktestAnalysisResult[this.cgIndex].AvgSectionRate * 100
                      ) < 0
                      ? 'greenDown'
                      : setSyTongBi(
                          yzData.backTest.BacktestAnalysisResult[this.cgIndex].AvgSectionRate * 100,
                          tyData.backTest.BacktestAnalysisResult[this.cgIndex].AvgSectionRate * 100
                        ) > 0
                      ? 'redTop'
                      : ''
                    : ''
                "
              ></i>
            </div>
          </van-col>
          <van-col span="6">
            <div
              class="data-text2 text-right"
              :class="
                judgeColor(
                  yzData.backTest && tyData.backTest
                    ? setSyTongBi(
                        yzData.backTest.BacktestAnalysisResult[this.cgIndex].AvgSectionRate * 100,
                        tyData.backTest.BacktestAnalysisResult[this.cgIndex].AvgSectionRate * 100
                      )
                    : 0
                )
              "
            >
              {{
                yzData.backTest && tyData.backTest
                  ? setSyTongBi(
                      yzData.backTest.BacktestAnalysisResult[this.cgIndex].AvgSectionRate * 100,
                      tyData.backTest.BacktestAnalysisResult[this.cgIndex].AvgSectionRate * 100
                    ) + '%'
                  : '--'
              }}
            </div>
          </van-col>
          <van-col span="6">
            <div class="data-text3 text-left">最大涨跌幅</div>
          </van-col>
          <van-col span="6">
            <div class="data-text2 text-right">
              {{
                yzData.backTest
                  ? toFixedNum(
                      yzData.backTest.BacktestAnalysisResult[this.cgIndex].MaxRate * 100,
                      2,
                      '%'
                    )
                  : '--'
              }}
            </div>
          </van-col>
          <van-col span="6">
            <div class="data-text2 text-right">
              {{
                tyData.backTest
                  ? toFixedNum(
                      tyData.backTest.BacktestAnalysisResult[this.cgIndex].MaxRate * 100,
                      2,
                      '%'
                    )
                  : '--'
              }}
              <i
                :class="
                  yzData.backTest && tyData.backTest
                    ? setSyTongBi(
                        yzData.backTest.BacktestAnalysisResult[this.cgIndex].MaxRate * 100,
                        tyData.backTest.BacktestAnalysisResult[this.cgIndex].MaxRate * 100
                      ) < 0
                      ? 'greenDown'
                      : setSyTongBi(
                          yzData.backTest.BacktestAnalysisResult[this.cgIndex].MaxRate * 100,
                          tyData.backTest.BacktestAnalysisResult[this.cgIndex].MaxRate * 100
                        ) > 0
                      ? 'redTop'
                      : ''
                    : ''
                "
              ></i>
            </div>
          </van-col>
          <van-col span="6">
            <div
              class="data-text2 text-right"
              :class="
                judgeColor(
                  yzData.backTest && tyData.backTest
                    ? setSyTongBi(
                        yzData.backTest.BacktestAnalysisResult[this.cgIndex].MaxRate * 100,
                        tyData.backTest.BacktestAnalysisResult[this.cgIndex].MaxRate * 100
                      )
                    : 0
                )
              "
            >
              {{
                yzData.backTest && tyData.backTest
                  ? setSyTongBi(
                      yzData.backTest.BacktestAnalysisResult[this.cgIndex].MaxRate * 100,
                      tyData.backTest.BacktestAnalysisResult[this.cgIndex].MaxRate * 100
                    ) + '%'
                  : '--'
              }}
            </div>
          </van-col>
          <van-col span="6">
            <div class="data-text3 text-left">最小涨跌幅</div>
          </van-col>
          <van-col span="6">
            <div class="data-text2 text-right">
              {{
                yzData.backTest
                  ? toFixedNum(
                      yzData.backTest.BacktestAnalysisResult[this.cgIndex].MinRate * 100,
                      2,
                      '%'
                    )
                  : '--'
              }}
            </div>
          </van-col>
          <van-col span="6">
            <div class="data-text2 text-right">
              {{
                tyData.backTest
                  ? toFixedNum(
                      tyData.backTest.BacktestAnalysisResult[this.cgIndex].MinRate * 100,
                      2,
                      '%'
                    )
                  : '--'
              }}
              <i
                :class="
                  yzData.backTest && tyData.backTest
                    ? setSyTongBi(
                        yzData.backTest.BacktestAnalysisResult[this.cgIndex].MinRate * 100,
                        tyData.backTest.BacktestAnalysisResult[this.cgIndex].MinRate * 100
                      ) < 0
                      ? 'greenDown'
                      : setSyTongBi(
                          yzData.backTest.BacktestAnalysisResult[this.cgIndex].MinRate * 100,
                          tyData.backTest.BacktestAnalysisResult[this.cgIndex].MinRate * 100
                        ) > 0
                      ? 'redTop'
                      : ''
                    : ''
                "
              ></i>
            </div>
          </van-col>
          <van-col span="6">
            <div
              class="data-text2 text-right"
              :class="
                judgeColor(
                  yzData.backTest && tyData.backTest
                    ? setSyTongBi(
                        yzData.backTest.BacktestAnalysisResult[this.cgIndex].MinRate * 100,
                        tyData.backTest.BacktestAnalysisResult[this.cgIndex].MinRate * 100
                      )
                    : 0
                )
              "
            >
              {{
                yzData.backTest && tyData.backTest
                  ? setSyTongBi(
                      yzData.backTest.BacktestAnalysisResult[this.cgIndex].MinRate * 100,
                      tyData.backTest.BacktestAnalysisResult[this.cgIndex].MinRate * 100
                    ) + '%'
                  : '--'
              }}
            </div>
          </van-col>
          <van-col span="6">
            <div class="data-text3 text-left">历史盈亏比</div>
          </van-col>
          <van-col span="6">
            <div class="data-text2 text-right">
              {{
                yzData.backTest
                  ? toFixedNum(
                      yzData.backTest.BacktestAnalysisResult[this.cgIndex].ProfitLossRatio,
                      2,
                      ''
                    )
                  : '--'
              }}
            </div>
          </van-col>
          <van-col span="6">
            <div class="data-text2 text-right">
              {{
                tyData.backTest
                  ? toFixedNum(
                      tyData.backTest.BacktestAnalysisResult[this.cgIndex].ProfitLossRatio,
                      2,
                      ''
                    )
                  : '--'
              }}
              <i
                :class="
                  yzData.backTest && tyData.backTest
                    ? setCommonTongBi(
                        yzData.backTest.BacktestAnalysisResult[this.cgIndex].ProfitLossRatio,
                        tyData.backTest.BacktestAnalysisResult[this.cgIndex].ProfitLossRatio
                      ) < 0
                      ? 'greenDown'
                      : setCommonTongBi(
                          yzData.backTest.BacktestAnalysisResult[this.cgIndex].ProfitLossRatio,
                          tyData.backTest.BacktestAnalysisResult[this.cgIndex].ProfitLossRatio
                        ) > 0
                      ? 'redTop'
                      : ''
                    : ''
                "
              ></i>
            </div>
          </van-col>
          <van-col span="6">
            <div
              class="data-text2 text-right"
              :class="
                judgeColor(
                  yzData.backTest && tyData.backTest
                    ? setCommonTongBi(
                        yzData.backTest.BacktestAnalysisResult[this.cgIndex].ProfitLossRatio,
                        tyData.backTest.BacktestAnalysisResult[this.cgIndex].ProfitLossRatio
                      )
                    : 0
                )
              "
            >
              {{
                yzData.backTest && tyData.backTest
                  ? setCommonTongBi(
                      yzData.backTest.BacktestAnalysisResult[this.cgIndex].ProfitLossRatio,
                      tyData.backTest.BacktestAnalysisResult[this.cgIndex].ProfitLossRatio
                    ) + '%'
                  : '--'
              }}
            </div>
          </van-col>
          <van-col span="6">
            <div class="data-text3 text-left">历史上涨概率</div>
          </van-col>
          <van-col span="6">
            <div class="data-text2 text-right">
              {{
                yzData.backTest
                  ? toFixedNum(
                      yzData.backTest.BacktestAnalysisResult[this.cgIndex].RiseProbability * 100,
                      2,
                      '%'
                    )
                  : '--'
              }}
            </div>
          </van-col>
          <van-col span="6">
            <div class="data-text2 text-right">
              {{
                tyData.backTest
                  ? toFixedNum(
                      tyData.backTest.BacktestAnalysisResult[this.cgIndex].RiseProbability * 100,
                      2,
                      '%'
                    )
                  : '--'
              }}
              <i
                :class="
                  yzData.backTest && tyData.backTest
                    ? setCommonTongBi(
                        yzData.backTest.BacktestAnalysisResult[this.cgIndex].RiseProbability,
                        tyData.backTest.BacktestAnalysisResult[this.cgIndex].RiseProbability
                      ) < 0
                      ? 'greenDown'
                      : setCommonTongBi(
                          yzData.backTest.BacktestAnalysisResult[this.cgIndex].RiseProbability,
                          tyData.backTest.BacktestAnalysisResult[this.cgIndex].RiseProbability
                        ) > 0
                      ? 'redTop'
                      : ''
                    : ''
                "
              ></i>
            </div>
          </van-col>
          <van-col span="6">
            <div
              class="data-text2 text-right"
              :class="
                judgeColor(
                  yzData.backTest && tyData.backTest
                    ? setCommonTongBi(
                        yzData.backTest.BacktestAnalysisResult[this.cgIndex].RiseProbability,
                        tyData.backTest.BacktestAnalysisResult[this.cgIndex].RiseProbability
                      )
                    : 0
                )
              "
            >
              {{
                yzData.backTest && tyData.backTest
                  ? setCommonTongBi(
                      yzData.backTest.BacktestAnalysisResult[this.cgIndex].RiseProbability,
                      tyData.backTest.BacktestAnalysisResult[this.cgIndex].RiseProbability
                    ) + '%'
                  : '--'
              }}
            </div>
          </van-col>
        </van-row>
      </div>
    </div>
    <van-empty
      v-if="mnQuery"
      class="custom-image"
      :image="not_data"
      description="您查看的报告已失效,下次要早点来哦~"
    />

    <!-- 选择 -->
    <van-action-sheet
      v-model="sheetShow"
      :actions="sheetActions"
      cancel-text="取消"
      close-on-click-action
      @cancel="onSheetCancel"
      @select="onSheetSelect"
    />
    <!-- 弹窗 -->
    <van-dialog
      v-model="dialogShow"
      :message="dialogMsg"
      className="dialog_box"
      confirmButtonText="我知道了"
      @confirm="closeErrDialog()"
    >
    </van-dialog>
    <!-- 加载遮罩 -->
    <van-overlay :show="showLoading" @click="show = false">
      <div class="wrapper">
        <van-loading color="#1989fa" size="24px" vertical>数据加载中...</van-loading>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import { getReportInfo, shareReport, getReportRedisById } from '@/api/report.js';
import { toFixedNum, judgeColor, formtTime, fangDouFun, getArrayIndex } from '@/utils/format';
import mixin from '@/mixins/index.js';
export default {
  name: '',
  mixins: [mixin],
  data() {
    return {
      not_data: require('../../assets/image/notData.png'),
      f_id: '',
      s_id: '',
      s_name: '',
      nameArr: [],
      nameEasy: '',
      loading: false,
      //  因子数据
      yzData: {},
      // 调优数据
      tyData: {},
      active: 0,
      // 持股标记
      cgIndex: 0,
      // 选择框
      sheetShow: false,
      sheetActions: [],
      // 头部概述
      textGl: '',
      textFirst: '',
      textSecond: '',
      textThird: '',
      // 显示全部模版
      showMbInfo: false,
      // 报告时间
      bgTime: '',
      // classID (分享id)
      classId: '',
      // 空状态
      mnQuery: false,
      // 落盘数据
      classNewZf: '',
      classOldZf: '',
      classNewXh: '',
      classOldXh: '',
      classNewYq: '',
      classOldYq: '',
      classInvitee: '',
      classStart:'',
      classEnd:'',
      // 分享数据
      searchInfo: false,

      // 弹窗
      dialogShow: false,
      dialogMsg: '',
      dialogEmpty: false,
      // 遮罩
      showLoading: true
    };
  },
  filters: {},
  // 侦听器
  watch: {},
  /**
   * 组件实例创建完成，属性已绑定，但DOM还未生成，$ el属性还不存在
   */
  created() {
    // 判断是否有classID
    this.classId = this.getUrlQuery('classId');
    if (this.classId == '') {
      // 不是分享,走查询逻辑
      // 获取url中的参数 并且赋值
      this.f_id = decodeURIComponent(this.getUrlQuery('factorid'));
      this.s_id = decodeURIComponent(this.getUrlQuery('mbid'));
      this.s_name = decodeURIComponent(this.getUrlQuery('mbname'));

      let nameArr = this.s_name.split(',');
      this.nameArr = nameArr;
      // 获取当前时间
      this.bgTime = formtTime(new Date(), 'yyyy-MM-dd hh:mm:ss');
      const nameEasy = '';
      // 判断有几个名称
      if (nameArr.length > 3) {
        this.nameEasy =
          nameArr[0] + '，' + nameArr[1] + '，' + nameArr[2] + '等' + nameArr.length + '个';
      } else {
        this.nameEasy = this.s_name;
      }

      this.getAllData();
    } else {
      // 是分享,走分享逻辑
      // 查询分享的数据
      let params = {
        classId: this.classId
      };
      getReportRedisById(params)
        .then((result) => {
          if (result.err == 200) {
            // 获取数据请求数据
            // console.log('result.data', result.data);
            this.f_id = result.data.factorId;
            this.s_id = result.data.mbId;
            this.s_name = result.data.mbName;
            let nameArr = this.s_name.split(',');
            this.nameArr = nameArr;
            // 判断有几个名称
            if (nameArr.length > 3) {
              this.nameEasy =
                nameArr[0] + '，' + nameArr[1] + '，' + nameArr[2] + '等' + nameArr.length + '个';
            } else {
              this.nameEasy = this.s_name;
            }
            this.bgTime = result.data.reportTime;
            this.mnQuery = false;

            // 赋值落盘数据
            this.classNewZf = result.data.newRiZhangFu;
            this.classOldZf = result.data.oldRiZhangFu;
            this.classNewXh = result.data.newXinHaoShu;
            this.classOldXh = result.data.oldXinHaoShu;
            this.classNewYq = result.data.newYuQing;
            this.classOldYq = result.data.oldYuQing;
            this.classInvitee = result.data.uname;
            this.classStart =  result.data.starDate;
            this.classEnd =  result.data.endDate;
            this.searchInfo = true;

            this.getAllData();
          } else {
            this.mnQuery = true;
            this.showLoading = false;
          }
        })
        .catch((err) => {});
    }
  },
  /**
   * el 被新创建的 vm.$ el 替换，并挂载到实例上去之后调用该钩子。
   * 如果 root 实例挂载了一个文档内元素，当 mounted 被调用时 vm.$ el 也在文档内。
   */
  mounted: function () {
    this.scrollviewBounces(1);
  },
  // 组件方法
  methods: {
    judgeColor,
    toFixedNum,
    //同时请求因子与调优的数据
    getAllData: function () {
      Promise.all([this.getReportYzFunc(), this.getReportTyFunc()])
        .then((result) => {
          this.loading = true;
          // 去除遮罩
          this.showLoading = false;
          // 因子数据
          this.yzData = result[0];
          //   调优数据
          this.tyData = result[1];

          // 赋值落盘数据
          if (this.searchInfo) {
            this.yzData.hq.RiZhangFu = this.classNewZf;
            this.tyData.hq.RiZhangFu = this.classOldZf;
            this.yzData.hq.XinHaoShuLiang = this.classNewXh;
            this.tyData.hq.XinHaoShuLiang = this.classOldXh;
            this.yzData.yqNumber = this.classNewYq;
            this.tyData.yqNumber = this.classOldYq;
          }

          //   其他逻辑
          // 渲染走势收益图
          this.renderZs();
          // 处理下拉框数据
          this.sheetActions = result[0].backTest.BacktestAnalysisResult.map((item) => {
            let obj = {
              name: '持股' + item.HoldPeriod + '天'
            };
            return obj;
          });
          // 处理描述文字
          result[0].hq.FactorName =  result[0].hq.FactorName? result[0].hq.FactorName:'自选';
          // 头部概览文字
          let textGl =
            '针对' + result[0].hq.FactorName + '因子，在参照' + this.nameEasy + '调优条件之后，';
          // 周and月收益率均提升10%及以上 and 三月and半年收益率均提升20%及以上 and 年收益率提升30%及以上
          //  近一周涨幅（变动） > 10
          //  近一月涨幅（变动） > 10
          //  近三月涨幅（变动） > 10
          //  近半年涨幅（变动）> 20
          //  近一年涨幅（变动）> 30
          if (
            this.setSyTongBi(this.yzData.syfx.StageIncome[0], this.tyData.syfx.StageIncome[0]) >=
              10 &&
            this.setSyTongBi(this.yzData.syfx.StageIncome[1], this.tyData.syfx.StageIncome[1]) >=
              10 &&
            this.setSyTongBi(this.yzData.syfx.StageIncome[2], this.tyData.syfx.StageIncome[2]) >=
              20 &&
            this.setSyTongBi(this.yzData.syfx.StageIncome[3], this.tyData.syfx.StageIncome[3]) >=
              20 &&
            this.setSyTongBi(this.yzData.syfx.StageIncome[4], this.tyData.syfx.StageIncome[4]) >= 30
          ) {
            this.textGl = textGl + '各项评价指标均有明显提升。';
          } else if (
            this.setSyTongBi(this.yzData.syfx.StageIncome[1], this.tyData.syfx.StageIncome[1]) >=
              10 &&
            this.setSyTongBi(this.yzData.syfx.StageIncome[4], this.tyData.syfx.StageIncome[4]) >= 30
          ) {
            // 月收益率提升10%及以上 and 年收益率提升30%及以上
            // month_rate_change >10% and  year_rate_change >30%:
            this.textGl = textGl + '主要指标提升较大。';
          } else if (this.getSyTongBiNum() >= 3) {
            // 周/月/三月/半年/年收益率 中的3项指标提升率大于0，则输出3
            // count(week_rate_change > 0 and month_rate_change >0 and  month3_rate_change >0 and halfyear_rate_change > 0 and year_rate_change >0) >=3:
            this.textGl = textGl + '各项数据提升不太明显。';
          } else {
            this.textGl = textGl + '总体数据表现不佳。';
          }
          //  短线文字
          let dxText = '从短线看，';
          // 升降文字: 空 上升 下降
          let sjText1 = '';
          //调优后日涨幅and调优后周收益都不是0
          if (
            this.tyData.hq.RiZhangFu &&
            this.tyData.hq.RiZhangFu !== 0 &&
            this.tyData.syfx.StageIncome[0] !== 0 &&
            this.setSyTongBi(this.yzData.hq.RiZhangFu, this.tyData.hq.RiZhangFu) !== 0 &&
            this.setSyTongBi(this.yzData.syfx.StageIncome[0], this.tyData.syfx.StageIncome[0]) !== 0
          ) {
            // 判断那个收益大
            if (this.tyData.hq.RiZhangFu + 1 > this.tyData.syfx.StageIncome[0] + 1) {
              // 涨幅
              dxText = dxText + '今日涨幅从' + toFixedNum(this.yzData.hq.RiZhangFu * 100, 2, '%');
              sjText1 = this.yzData.hq.RiZhangFu < this.tyData.hq.RiZhangFu ? '上升' : '下降';
              let sjText2 = this.yzData.hq.RiZhangFu < this.tyData.hq.RiZhangFu ? '提升' : '降低';
              dxText =
                dxText +
                sjText1 +
                '到' +
                this.toFixedNum(this.tyData.hq.RiZhangFu * 100, 2, '%') +
                '，' +
                sjText2 +
                '了' +
                this.setSyTongBi(this.yzData.hq.RiZhangFu * 100, this.tyData.hq.RiZhangFu * 100) +
                '%。';
            } else {
              // 近一周涨跌幅
              dxText =
                dxText + '近一周涨跌幅从' + toFixedNum(this.yzData.syfx.StageIncome[0], 2, '%');
              sjText1 =
                this.yzData.syfx.StageIncome[0] < this.tyData.syfx.StageIncome[0] ? '上升' : '下降';
              let sjText2 =
                this.yzData.syfx.StageIncome[0] < this.tyData.syfx.StageIncome[0] ? '提升' : '降低';
              dxText =
                dxText +
                sjText1 +
                '到' +
                this.toFixedNum(this.tyData.syfx.StageIncome[0], 2, '%') +
                '，' +
                sjText2 +
                '了' +
                this.setSyTongBi(this.yzData.syfx.StageIncome[0], this.tyData.syfx.StageIncome[0]) +
                '%。';
            }
          } else {
            dxText = dxText + '近期收益率涨幅变化不明显。';
          }
          // 设置第一段文字
          this.textFirst = dxText;

          // 长线文字
          let cxText = '从长线看，调优后';
          // 长线升降文字 : 空 上升 下降
          let cxsjText = '';
          if (
            this.tyData.syfx.StageIncome[3] !== 0 &&
            this.tyData.syfx.StageIncome[4] !== 0 &&
            this.setSyTongBi(this.yzData.syfx.StageIncome[3], this.tyData.syfx.StageIncome[3]) !==
              0 &&
            this.setSyTongBi(this.yzData.syfx.StageIncome[4], this.tyData.syfx.StageIncome[4]) !== 0
          ) {
            if (
              100 + this.tyData.syfx.StageIncome[3] * 1 >
              100 + this.tyData.syfx.StageIncome[4] * 1
            ) {
              // 近半年
              cxText = cxText + '近半年涨跌幅' + this.yzData.syfx.StageIncome[3] + '%';
              cxsjText =
                this.yzData.syfx.StageIncome[3] < this.tyData.syfx.StageIncome[3] ? '上升' : '下降';
              let sjText2 =
                this.yzData.syfx.StageIncome[3] < this.tyData.syfx.StageIncome[3]
                  ? '，表现出较为乐观的信号。'
                  : '，信号表现不够乐观。';
              cxText = cxText + cxsjText + '到' + this.tyData.syfx.StageIncome[3] + '%' + sjText2;
            } else {
              // 近一年
              cxText = cxText + '近一年涨跌幅' + this.yzData.syfx.StageIncome[4] + '%';
              cxsjText =
                this.yzData.syfx.StageIncome[4] < this.tyData.syfx.StageIncome[4] ? '上升' : '下降';
              let sjText2 =
                this.yzData.syfx.StageIncome[4] < this.tyData.syfx.StageIncome[4]
                  ? '，表现出较为乐观的信号。'
                  : '，信号表现不够乐观。';
              cxText = cxText + cxsjText + '到' + this.tyData.syfx.StageIncome[4] + '%' + sjText2;
            }
          } else {
            cxText = cxText + '年化收益率变化效果不明显，长线收益一般';
          }
          let topDescText = '';
          if (sjText1 == '上升' && cxsjText == '上升') {
            topDescText = '此外，';
          } else if (sjText1 == '上升' && (cxsjText == '下降' || cxsjText == '')) {
            topDescText = '但是，';
          } else if ((sjText1 == '下降' || sjText1 == '') && cxsjText == '上升') {
            topDescText = '但是，';
          } else if (
            (sjText1 == '下降' || sjText1 == '') &&
            (cxsjText == '下降' || cxsjText == '')
          ) {
            topDescText = '此外，';
          }

          this.textSecond = topDescText + cxText;

          // 设置第三段话术
          let maxIndex = this.computeJdtjFunc();
          let descTextInfo =
            '观察阶段数据,当持股期为' +
            this.tyData.backTest.BacktestAnalysisResult[maxIndex].HoldPeriod +
            '天时，';
          let judgeText = '';
          let ProfitLossRatioText = '';
          // 判断盈亏比 (调优前的盈亏比 比较 调优后的盈亏比)
          if (
            this.yzData.backTest.BacktestAnalysisResult[maxIndex].ProfitLossRatio >
            this.tyData.backTest.BacktestAnalysisResult[maxIndex].ProfitLossRatio
          ) {
            judgeText = '下降';
            ProfitLossRatioText =
              '从' +
              toFixedNum(
                this.yzData.backTest.BacktestAnalysisResult[maxIndex].ProfitLossRatio,
                2,
                ''
              ) +
              judgeText +
              '到' +
              toFixedNum(
                this.tyData.backTest.BacktestAnalysisResult[maxIndex].ProfitLossRatio,
                2,
                ''
              ) +
              '，';
          } else if (
            this.yzData.backTest.BacktestAnalysisResult[maxIndex].ProfitLossRatio <
            this.tyData.backTest.BacktestAnalysisResult[maxIndex].ProfitLossRatio
          ) {
            judgeText = '上升';
            ProfitLossRatioText =
              '从' +
              toFixedNum(
                this.yzData.backTest.BacktestAnalysisResult[maxIndex].ProfitLossRatio,
                2,
                ''
              ) +
              judgeText +
              '到' +
              toFixedNum(
                this.tyData.backTest.BacktestAnalysisResult[maxIndex].ProfitLossRatio,
                2,
                ''
              ) +
              '，';
          } else {
            judgeText = '持平';
            ProfitLossRatioText = judgeText;
          }
          descTextInfo = descTextInfo + '历史盈亏比' + ProfitLossRatioText;
          // 判断上涨概率
          let judgeGlText = '';
          let RiseProbabilityText = '';
          if (
            this.yzData.backTest.BacktestAnalysisResult[maxIndex].RiseProbability >
            this.tyData.backTest.BacktestAnalysisResult[maxIndex].RiseProbability
          ) {
            judgeGlText = '下降';
            RiseProbabilityText =
              '从' +
              toFixedNum(
                this.yzData.backTest.BacktestAnalysisResult[maxIndex].RiseProbability * 100,
                2,
                '%'
              ) +
              judgeGlText +
              '到' +
              toFixedNum(
                this.tyData.backTest.BacktestAnalysisResult[maxIndex].RiseProbability * 100,
                2,
                '%'
              ) +
              '，';
          } else if (
            this.yzData.backTest.BacktestAnalysisResult[maxIndex].RiseProbability <
            this.tyData.backTest.BacktestAnalysisResult[maxIndex].RiseProbability
          ) {
            judgeGlText = '上升';
            RiseProbabilityText =
              '从' +
              toFixedNum(
                this.yzData.backTest.BacktestAnalysisResult[maxIndex].RiseProbability * 100,
                2,
                '%'
              ) +
              judgeGlText +
              '到' +
              toFixedNum(
                this.tyData.backTest.BacktestAnalysisResult[maxIndex].RiseProbability * 100,
                2,
                '%'
              ) +
              '，';
          } else {
            judgeGlText = '持平';
            RiseProbabilityText = judgeGlText;
          }
          descTextInfo = descTextInfo + '历史上涨概率' + RiseProbabilityText;

          if (judgeText == '上升' && judgeGlText == '上升') {
            descTextInfo = descTextInfo + '策略表现比较理想。';
          } else {
            descTextInfo = descTextInfo + '策略表现不够理想。';
          }
          this.textThird = descTextInfo;
        })
        .catch((error) => {
          this.dialogShow = true;
          this.dialogEmpty = true;
          // console.log(error);
        });
    },
    // 切换tabs
    onClickTabs: function (name, title) {
      if (name == 1) {
        this.$nextTick(() => {
          this.renderZdfb();
        });
      } else if (name == 2) {
        this.$nextTick(() => {
          this.renderHyfb();
          this.renderHyfb2();
        });
      }
    },

    // 获取因子的数据
    getReportYzFunc: function () {
      return new Promise((resolve, reject) => {
        let params = {
          factorID: this.f_id,
          type: 'yz',
          invitee: this.classInvitee,
          start:this.classStart,
          end:this.classEnd,
        };
        getReportInfo(params)
          .then((result) => {
            if (result.err == 200) {
              resolve(result.data);
            } else {
              this.dialogMsg = '暂不支持查看报告，请修改条件后再次尝试';
              reject(result.msg);
            }
          })
          .catch((err) => {
            this.dialogMsg = 'AI报告服务当前繁忙，请稍后再次进行尝试';
            this.dialogShow = true;
            this.dialogEmpty = true;
            reject(err);
          });
      });
    },
    // 获取因子+调优模版的数据
    getReportTyFunc: function () {
      return new Promise((resolve, reject) => {
        let params = {
          factorID: this.s_id,
          type: 'cl',
          invitee: this.classInvitee,
          start:this.classStart,
          end:this.classEnd,
        };
        getReportInfo(params)
          .then((result) => {
            if (result.err == 200) {
              resolve(result.data);
            } else {
              this.dialogMsg = '所选条件暂不支持查看报告，请修改条件后再次尝试';
              reject(result.msg);
            }
          })
          .catch((err) => {
            this.dialogMsg = 'AI报告服务当前繁忙，请稍后再次进行尝试';
            this.dialogShow = true;
            this.dialogEmpty = true;
            reject(err);
          });
      });
    },
    // 走势收益图跟数据渲染
    renderZs: function () {
      var chartDom = document.getElementById('zssy');
      var myChart = this.$echarts.init(chartDom);
      let rawData = this.yzData.syfx.Tradday.length;
      var option;
      option = {
        tooltip: {
          trigger: 'axis',
          backgroundColor: 'rgba(107, 118, 135, 0.7)',
          borderWidth: 0,
          textStyle: {
            color: '#E4E9FE',
            fontSize: 12
          },
          axisPointer: {
            type: 'line',
            lineStyle: {
              type: 'solid'
            }
          },
          padding: [0, 0, 0, 0],
          position: function (point, params, dom, rect, size) {
            // 鼠标坐标和提示框位置的参考坐标系是：以外层div的左上角那一点为原点，x轴向右，y轴向下
            // 提示框位置
            var x = 0; // x坐标位置
            var y = 0; // y坐标位置

            // 当前鼠标位置
            var pointX = point[0];
            var pointY = point[1];

            // 外层div大小
            // var viewWidth = size.viewSize[0];
            // var viewHeight = size.viewSize[1];

            // 提示框大小
            var boxWidth = size.contentSize[0];
            var boxHeight = size.contentSize[1];

            // boxWidth > pointX 说明鼠标左边放不下提示框
            if (boxWidth > pointX) {
              x = 5;
            } else {
              // 左边放的下
              x = pointX - boxWidth;
            }

            // boxHeight > pointY 说明鼠标上边放不下提示框
            if (boxHeight > pointY) {
              y = 5;
            } else {
              // 上边放得下
              y = pointY - boxHeight;
            }

            return [x, y];
          },
          formatter: function (param) {
            var result = `<p style="font-size: 10px;margin-bottom: 2px;">日期: ${param[0].axisValue}</p>`;
            param.forEach((element, index) => {
              result += `<p style="font-size: 10px;margin-bottom: 2px;">${element.marker}${element.seriesName}</p>
	                             <p style="margin-bottom: 1px;">收益率：${element.value}% </p>`;
            });
            return result;
          }
        },
        legend: {
          data: ['调优前', '调优后'],
          icon: 'rect',
          itemWidth: 8,
          itemGap: 16,
          itemHeight: 3,
          itemWidth: 8,
          top: 0,
          textStyle: {
            color: '#999',
            fontSize: 12 // 文字的字体大小。
          }
        },
        color: ['#286DF7', '#FE7400'],

        grid: {
          left: 10,
          top: 25,
          right: 10,
          bottom: 0,
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: this.yzData.syfx.Tradday,
          boundaryGap: false,
          axisTick: {
            show: false
          },
          axisLabel: {
            interval: 900000000, //度标签的显示间隔 前一个标签和下一个标签的间隔
            showMaxLabel: true, //是否显示最大的
            margin: 13,
            align: 'center',

            formatter: function (value, index) {
              //给第一个标签 和 最后一个标签 增加标识 设置样式用
              let text = '';
              if (0 == index) {
                text = '{a|' + value + '}';
              }
              if (rawData - 1 == index) {
                text = '{b|' + value + '}';
              }
              return text;
            },
            rich: {
              //给标签文字设置样式 左右留出一些位置
              a: {
                padding: [0, 0, 0, 0]
              },
              b: {
                padding: [0, 0, 0, -50]
              }
            }
          }
        },
        yAxis: [
          {
            type: 'value',
            position: 'left', //坐标轴位置，移至右边
            // name: '涨幅',
            splitLine: {
              lineStyle: {
                width: 0.5,
                // type: 'dashed',
                color: '#F0F0F0'
              }
            },
            axisLabel: {
              show: true,
              //Y轴数值可添加百分号
              formatter: '{value}%'
            }
          }
        ],
        series: [
          {
            name: '调优前',
            data: this.yzData.syfx.NetValue,
            type: 'line',
            smooth: true,
            showSymbol: false,
            areaStyle: {
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: 'rgba(40, 109, 247, 0.2)' },
                { offset: 0.3, color: 'rgba(40, 109, 247,0.1)' },
                { offset: 1, color: 'rgba(40, 109, 247,0)' }
              ])
            }
          },
          {
            name: '调优后',
            data: this.tyData.syfx.NetValue,
            type: 'line',
            smooth: true,
            showSymbol: false,
            areaStyle: {
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: 'rgba(254, 116, 0, 0.2)' },
                { offset: 0.3, color: 'rgba(254, 116, 0,0.1)' },
                { offset: 1, color: 'rgba(254, 116, 0,0)' }
              ])
            }
          }
        ]
      };
      option && myChart.setOption(option);
    },
    // 渲染涨跌分布
    renderZdfb: function () {
      const fbData1 = this.yzData.hq.ZhangDieTongJi.map((item) => {
        return (item / this.yzData.hq.XinHaoShuLiang) * 100;
      });
      const fbData2 = this.tyData.hq.ZhangDieTongJi.map((item) => {
        return (item / this.tyData.hq.XinHaoShuLiang) * 100;
      });
      // 获取涨跌分布
      var chartDom = document.getElementById('zdfb');
      var myChart = this.$echarts.init(chartDom);
      var option;
      option = {
        legend: {
          data: ['调优前', '调优后'],
          icon: 'rect',
          itemWidth: 8,
          itemGap: 16,
          itemHeight: 3,
          itemWidth: 8,
          top: 0,
          textStyle: {
            color: '#999',
            fontSize: 12 // 文字的字体大小。
          }
        },
        color: ['#286DF7', '#FE7400'],
        grid: {
          left: 10,
          top: 40,
          right: 20,
          bottom: 0,
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: ['跌停', '≤-5%', '-5~-2%', '-2~0%', '平', '0~2%', '2~5%', '≥5%', '涨停'],
          boundaryGap: false,
          axisTick: {
            show: false
          },
          axisLabel: {
            interval: 0, //横轴信息全部显示
            formatter: function (params) {
              let newParamsName = '';
              const paramsNameNumber = params.length; // 文字总长度
              const provideNumber = 3; //一行显示几个字
              const rowNumber = Math.ceil(paramsNameNumber / provideNumber);
              if (paramsNameNumber > provideNumber) {
                for (let p = 0; p < rowNumber; p++) {
                  const start = p * provideNumber;
                  const end = start + provideNumber;
                  const tempStr =
                    p === rowNumber - 1
                      ? params.substring(start, paramsNameNumber)
                      : params.substring(start, end) + '\n';
                  newParamsName += tempStr;
                }
              } else {
                newParamsName = params;
              }
              return newParamsName;
            }
          }
        },
        yAxis: [
          {
            type: 'value',
            name: '占比 %'
          }
        ],
        series: [
          {
            name: '调优前',
            type: 'bar',
            data: [
              fbData1[1],
              fbData1[2],
              fbData1[3],
              fbData1[4],
              fbData1[10],
              fbData1[5],
              fbData1[6],
              fbData1[7],
              fbData1[0]
            ],
            itemStyle: {
              barBorderRadius: [3, 3, 0, 0]
            }
          },
          {
            name: '调优后',
            type: 'bar',
            data: [
              fbData2[1],
              fbData2[2],
              fbData2[3],
              fbData2[4],
              fbData2[10],
              fbData2[5],
              fbData2[6],
              fbData2[7],
              fbData2[0]
            ],
            itemStyle: {
              barBorderRadius: [3, 3, 0, 0]
            }
          }
        ]
      };
      option && myChart.setOption(option);
    },
    // 渲染行业分布
    renderHyfb: function () {
      const pieData = this.yzData.hq.HangYeFenBu;
      // 获取涨跌分布
      var chartDom = document.getElementById('hyfbFront');
      var myChart = this.$echarts.init(chartDom);
      var option;
      option = {
        tooltip: {
          show: false,
          trigger: 'item'
          // formatter: function (param) {
          //   return param.marker + param.name + ': ' + toFixedNum(param.value * 100, 2, '%');
          // }
        },
        legend: {
          icon: 'circle',
          orient: 'horizontal', //水平显示
          bottom: 0,
          itemGap: 8, //间隙
          itemWidth: 6, //圆点直径
          align: 'left', //图例标记和文本的对齐。默认自动
          textStyle: {
            color: '#555',
            fontSize: 12
          }
        },
        series: [
          {
            type: 'pie',
            center: ['50%', '35%'],
            radius: ['30%', '70%'],
            legendHoverLink: true, //hover 时的联动高亮
            avoidLabelOverlap: true, //是否启用防止标签重叠策略，默认开启，在标签拥挤重叠的情况下会挪动各个标签的位置，防止标签间的重叠。
            stillShowZeroSum: false, //是否在数据和为0（一般情况下所有数据为0） 的时候仍显示扇区。
            percentPrecision: '2', //饼图百分比数值的精度，默认保留小数点后两位。

            data: pieData.map((item) => ({
              value: item.ZhanBi,
              name: item.IndustryName
            })),

            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(255, 255, 255, 0.5)'
              }
            },

            label: {
              //echarts饼图内部显示百分比设置
              show: false,
              position: 'inside', //outside 外部显示  inside 内部显示
              formatter: `{d}%`,
              color: '#ffffff', //颜色
              fontSize: 12 //字体大小
            }
          }
        ]
      };
      option && myChart.setOption(option);
    },
    renderHyfb2: function () {
      const pieData = this.tyData.hq.HangYeFenBu;
      // 获取涨跌分布
      var chartDom = document.getElementById('hyfbBehind');
      var myChart = this.$echarts.init(chartDom);
      var option;
      option = {
        tooltip: {
          show: false,
          trigger: 'item',
          formatter: function (param) {
            return param.marker + param.name + ': ' + toFixedNum(param.value * 100, 2, '%');
          }
        },
        legend: {
          icon: 'circle',
          orient: 'horizontal', //水平显示
          bottom: 0,
          itemGap: 8, //间隙
          itemWidth: 6, //圆点直径
          align: 'left', //图例标记和文本的对齐。默认自动
          textStyle: {
            color: '#555',
            fontSize: 12
          }
        },
        series: [
          {
            type: 'pie',
            center: ['50%', '35%'],
            radius: ['30%', '70%'],
            legendHoverLink: true, //hover 时的联动高亮
            avoidLabelOverlap: true, //是否启用防止标签重叠策略，默认开启，在标签拥挤重叠的情况下会挪动各个标签的位置，防止标签间的重叠。
            stillShowZeroSum: false, //是否在数据和为0（一般情况下所有数据为0） 的时候仍显示扇区。
            percentPrecision: '2', //饼图百分比数值的精度，默认保留小数点后两位。

            data: pieData.map((item) => ({
              value: item.ZhanBi,
              name: item.IndustryName
            })),

            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(255, 255, 255, 0.5)'
              }
            },

            label: {
              //echarts饼图内部显示百分比设置
              show: false,
              position: 'inside', //outside 外部显示  inside 内部显示
              formatter: `{d}%`,
              color: '#ffffff', //颜色
              fontSize: 12 //字体大小
            }
          }
        ]
      };
      option && myChart.setOption(option);
    },
    // 设置收益同比
    setSyTongBi: function (num1, num2) {
      var setNum = (1 + num2 / 100) / (1 + num1 / 100) - 1;
      // console.log(setNum,'==========',num1,num2,'-----------------',Number(setNum * 100).toFixed(2));
      return Number(setNum * 100).toFixed(2);
    },
    // 设置舆情数
    setYqNum: function (num1, num2) {
      var setNum = num1 / num2;
      return Number(setNum).toFixed(2);
    },
    // 这是舆情同比
    setYqTongBi: function (num1, num2) {
      //（调优后数据-调优前数据）/调优前数据
      var setNum =
        (num2 / this.tyData.hq.XinHaoShuLiang - num1 / this.yzData.hq.XinHaoShuLiang) /
        (num1 / this.yzData.hq.XinHaoShuLiang);
      if (isNaN(setNum)) {
        setNum = 0;
      }
      return Number(setNum * 100).toFixed(2);
    },
    // 设置其他同比
    setCommonTongBi: function (num1, num2) {
      //（调优后数据-调优前数据）/调优前数据
      var setNum = (num2 - num1) / num1;
      return Number(setNum * 100).toFixed(2);
    },
    // 取消弹窗
    onSheetCancel: function () {},
    // 开启选择弹窗
    showSheet: function () {
      this.sheetShow = true;
    },
    // 弹窗选择条件
    onSheetSelect: function (action, index) {
      this.cgIndex = index;
    },
    // 判断返回收益大于零的同比个数
    getSyTongBiNum: function () {
      //周/月/三月/半年/年收益率 中的3项指标提升率大于0，则输出3
      let num = 0;
      if (this.setSyTongBi(this.yzData.syfx.StageIncome[0], this.tyData.syfx.StageIncome[0]) > 0) {
        num = num + 1;
      }
      if (this.setSyTongBi(this.yzData.syfx.StageIncome[1], this.tyData.syfx.StageIncome[1]) > 0) {
        num = num + 1;
      }
      if (this.setSyTongBi(this.yzData.syfx.StageIncome[2], this.tyData.syfx.StageIncome[2]) > 0) {
        num = num + 1;
      }
      if (this.setSyTongBi(this.yzData.syfx.StageIncome[3], this.tyData.syfx.StageIncome[3]) > 0) {
        num = num + 1;
      }
      if (this.setSyTongBi(this.yzData.syfx.StageIncome[4], this.tyData.syfx.StageIncome[4]) > 0) {
        num = num + 1;
      }

      return num;
    },
    // 计算阶段统计数据的index值
    computeJdtjFunc: function () {
      let setIndex = 0;
      // 获取调优后的回测阶段统计
      let BacktestAnalysisResult = this.tyData.backTest.BacktestAnalysisResult;
      if (BacktestAnalysisResult.length > 0) {
        let newArr = [];
        BacktestAnalysisResult.forEach((item, index) => {
          let maxNum = 0;
          maxNum = item.ProfitLossRatio * item.RiseProbability;
          newArr.push(maxNum);
        });
        var max = Math.max(...newArr);
        setIndex = newArr.map((item) => item).indexOf(max);
        return setIndex;
      } else {
        return setIndex;
      }
    },
    showMbName: function () {
      this.showMbInfo = !this.showMbInfo;
    },
    // 调用功能号 关闭当前页面
    closeHtml: function () {
      window.location.href = 'dzh_browser_url&goto=0&screen=263';
    },
    // 调用功能号 打开分享
    shareHtml: function () {
      // 如果是分享直接走分享地址
      const currentUrl = window.location.href;
      if (this.searchInfo) {
        console.log('我的分享地址');
        return;
      }

      // 请求AI报告分享数据
      let params = {
        factorId: this.f_id,
        mbId: this.s_id,
        mbName: this.s_name,
        reportTime: this.bgTime,
        factorName: this.yzData.hq.FactorName,
        earningsYear: toFixedNum(this.tyData.syfx.StageIncome[4], 2, ''),
        newRiZhangFu: this.yzData.hq.RiZhangFu ? this.yzData.hq.RiZhangFu : 0.0,
        oldRiZhangFu: this.tyData.hq.RiZhangFu ? this.tyData.hq.RiZhangFu : 0.0,
        newXinHaoShu: this.yzData.hq.XinHaoShuLiang,
        oldXinHaoShu: this.tyData.hq.XinHaoShuLiang,
        newYuQing: this.yzData.yqNumber,
        oldYuQing: this.tyData.yqNumber
      };
      shareReport(params)
        .then((result) => {
          if (result.err == 200) {
            window.location.href = result.data;
          } else {
          }
        })
        .catch((err) => {});
    },
    closeErrDialog: function () {
      this.dialogShow = false;
      window.location.href = 'dzh_browser_url&goto=0&screen=263';
    }
  }
};
</script>

<style lang="less" scoped>
// 报告头部导航栏
.background-report {
  background: url('../../assets/image/blockImg/report-background.png') top no-repeat;
  background-size: 100%;
  min-height: 100vh;
}
.haider-info {
  padding-top: 44px;
}
.van-nav-bar {
  background-color: transparent;
}

::v-deep {
  .van-nav-bar__title {
    color: #fff !important;
    text-align: center;
    font-size: 16px;
    font-weight: 500;
  }
  .van-empty__description {
    color: #fff;
  }
  .van-hairline--bottom::after {
    border-bottom-width: 0px;
  }
}

.right-icon {
  width: 17px;
  height: 18.5px;
  // border: 1px solid red;
  background: url('../../assets/image/blockImg/Share.png') top no-repeat;
  background-size: 100%;
  font-size: 16px;
  display: block;
}

// 报告时间
.report-time {
  text-align: center;
  color: #fff;
  font-size: 12px;
  margin: 10px auto;
}
// 文字靠右
.text-right-info {
  text-align: right;
  color: #222;
  font-size: 12px;
  font-weight: 500;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-content: center;
  justify-content: flex-end;
  align-items: center;
}
.text-right-icon {
  width: 4px;
  height: 3px;
  display: inline-block;
  background: url('../../assets/image/blockImg/xiala.png') top no-repeat;
  background-size: 100%;
  margin-left: 4px;
}

// 内容页
.report-content {
  // height: 100vh;
  height: calc(100vh - 130px);
  padding: 12px;
  overflow: hidden;
  overflow-y: auto;
  .content-bg {
    background: #fff;
    border-radius: 8px;
    padding: 16px;
    margin-bottom: 8px;
  }

  // 居中
  .text-flex-conten {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-content: center;
    align-items: center;
    justify-content: space-between;
  }

  .redTop {
    width: 10.5px;
    height: 6px;
    // border: 1px solid red;
    background: url('../../assets/image/blockImg/red-top.png') top no-repeat;
    background-size: 100%;
    display: inline-block;
    // margin-left: 4px;
  }
  .greenDown {
    width: 10.5px;
    height: 6px;
    // border: 1px solid red;
    background: url('../../assets/image/blockImg/green-down.png') top no-repeat;
    background-size: 100%;
    display: inline-block;
    // margin-left: 4px;
  }

  // 概览
  .content-gl {
    .gl-title {
      text-align: center;
      font-size: 16px;
      color: var(--colours-text-1, #222);
      font-weight: 500;
    }
    .gl-code {
      text-align: center;
      color: var(--colours-text-3, #999);
      font-size: 12px;
      font-weight: 400;
    }
    .gl-tycs {
      .gl-tycs-title {
        color: var(--colours-text-2, #555);
        font-size: 12px;
      }
      .downI {
        width: 10px;
        height: 10px;
        display: inline-block;
        background: url('../../assets/image/blockImg/down-one.png') top no-repeat;
        background-size: 100%;
        margin-left: 4px;
      }
      .topI {
        width: 10px;
        height: 10px;
        display: inline-block;
        background: url('../../assets/image/blockImg/top-one.png') top no-repeat;
        background-size: 100%;
        margin-left: 4px;
      }
    }
    .gl-item {
      ul {
        height: 20px;
        overflow: hidden;
      }
      li {
        display: inline-block;
        background: rgba(40, 109, 247, 0.05);
        border-radius: 53px;
        margin-right: 4px;
        padding: 2px 8px;
        color: var(--colours-blue, #3b85fe);
        text-align: center;
        font-size: 12px;
        margin-bottom: 6px;
      }
    }
    .max-gl-item {
      ul {
        height: auto;
        overflow: none;
      }
    }
    .gl-desc {
      background: #f7f8fa;
      padding: 12px 16px;
      border-radius: 6px;
      margin-top: 10px;
      .gl-desc-title {
        color: #555;
        font-size: 14px;
        font-weight: 400;
        line-height: 24px;
        .desc-title-top {
          font-size: 16px;
          color: var(--colours-blue, #286df7);
          padding-right: 10px;
        }
      }
      .gl-desc-item {
        .item-list {
          // border: 1px solid red;
          display: flex;
          .item-list-d {
            width: 10px;
            // border: 1px solid red;
            margin-right: 5px;
            i {
              width: 5px;
              height: 5px;
              background: #286df7;
              display: block;
              border-radius: 50%;
              margin-top: 10px;
            }
          }
          .item-list-t {
            color: var(--colours-text-2, #555);
            font-size: 14px;
            font-style: normal;
            font-weight: 400;
            line-height: 24px;
          }
        }
      }
    }
  }

  //   行情
  .content-hq {
    .content-hq-title {
      padding: 0px 16px;
      color: #222;
      font-size: 16px;
      font-weight: 500;
    }
    .content-hq-item {
      background: var(--colours-block-1, #f7f8fa);
      border-radius: 6px;
      padding: 8px 16px;
      margin-top: 5px;
      .item-left {
        font-size: 12px;
        color: #999;
        font-weight: 400;
        margin-right: 12px;
      }
      .item-right {
        color: #222;
        font-size: 16px;
        font-weight: 500;
      }
    }
  }
  //   图表
  .content-tb {
    padding: 12px 0;
    ::v-deep {
      .van-tabs__wrap {
        width: 70%;
      }
      .van-tabs--line .van-tabs__wrap {
        height: 35px !important;
      }
    }

    .tb-height {
      height: 170px;
      // padding: 12px 16px;
      padding: 5px 0;
    }
    .tb-height2 {
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      padding: 5px 12px;
      .tb-chart {
        background: #f7f8fa;
        border-radius: 8px;
        width: 50%;
        .hyfb-text {
          font-size: 12px;
          color: #555;
          text-align: left;
          padding-left: 16px;
          padding-top: 4px;
        }
        .hyfb-chart {
          width: 100%;
          height: 190px;
        }
      }
    }
  }

  //    数据报告
  .content-data {
    .data-text {
      color: #999;
      font-size: 12px;
      font-weight: 400;
    }
    .text-left {
      text-align: left;
    }
    .text-right {
      text-align: right;
    }
    .data-title {
      border-radius: 6px;
      background: rgba(0, 0, 0, 0.02);
      margin: 12px 0;
      color: #555;
      font-size: 12px;
      font-weight: 400;
      padding: 8px;
    }
    .data-text2 {
      color: #555;
      font-size: 12px;
      font-weight: 400;
      margin-bottom: 12px;
    }
    .data-text3 {
      color: #555;
      font-size: 12px;
      font-weight: 400;
    }
  }
}

// 遮罩样式
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
</style>
